import { render, staticRenderFns } from "./ModalWinLoseChoice.vue?vue&type=template&id=82215236&scoped=true&"
import script from "./ModalWinLoseChoice.vue?vue&type=script&lang=js&"
export * from "./ModalWinLoseChoice.vue?vue&type=script&lang=js&"
import style0 from "./ModalWinLoseChoice.vue?vue&type=style&index=0&id=82215236&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82215236",
  null
  
)

export default component.exports